import { render } from "./accountAddressForm.vue?vue&type=template&id=6d77e7be"
import script from "./accountAddressForm.vue?vue&type=script&lang=js"
export * from "./accountAddressForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__